const ErrorCallCenter = () => {

    if (document.querySelector('.errorCallCenter__animacion__hidden')) {
        const errorToast = document.querySelector('.errorCallCenter__animacion__hidden'),
            errorToastCloseBtn = document.querySelector('.errorCallCenter__close');
           

        const fadeOutUp = element => {
            element.classList.remove('fadeInUp');
            element.classList.add('fadeOutUp');
        };

        errorToastCloseBtn.addEventListener('click', () => fadeOutUp(errorToast));
        setTimeout(() => errorToast.style.animationDelay = 0, 700);
    }
};

module.exports = {
    init: () => {
        ErrorCallCenter();
    }
};


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/components/errorCallCenter.js